import { can } from "./permission.js";
import { is } from "./roles";

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.can = can;
    Vue.prototype.is = is;
  },
};
